const v = require('voca');
export const getBuilderURL = (version) => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = `http://${domainName}:6075/`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    domainName = domainName.replace('builderc.webkonnect.digital', 'builder.webkonnect.digital');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builderc.mydrapcode.com', 'builder.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};

export const createUrl = (projectDetail, webhookId, type, trim = false) => {
  const { REACT_APP_ENVIRONMENT, REACT_APP_EXCHANGE_ENGINE_PREVIEW, REACT_APP_EXCHANGE_ENGINE } =
    process.env;
  let protocal = 'https';
  if (!REACT_APP_ENVIRONMENT || REACT_APP_ENVIRONMENT === 'DEV') {
    protocal = 'http';
  }
  if (projectDetail) {
    const { seoName } = projectDetail;
    let url = '';
    if (type === 'mapping') {
      url = `${protocal}://${seoName}.${REACT_APP_EXCHANGE_ENGINE_PREVIEW}api/v1/webhooks/${webhookId}/mapping-data`;
    } else if (type === 'build') {
      url = `${protocal}://${seoName}.${REACT_APP_EXCHANGE_ENGINE}api/v1/webhooks/${webhookId}/process-data`;
    } else if (type === 'preview') {
      url = `${protocal}://${seoName}.${REACT_APP_EXCHANGE_ENGINE_PREVIEW}api/v1/webhooks/${webhookId}/process-data`;
    } else {
      return '';
    }

    if (!trim) {
      return url;
    }

    return v.truncate(url, 60, '(...)');
  }
};

export const createFieldKey = (fieldName, trim = false) => {
  if (fieldName) {
    let fieldNameKey = `{{${fieldName}}}`;
    if (!trim) {
      return fieldNameKey;
    }
    return v.truncate(fieldNameKey, 60, '(...)');
  }
};
